class Maths {
  operators = {
    "+": (a, b) => a + b,
    "-": (a, b) => a - b,
    "%": (a, b) => a % b,
    "*": (a, b) => a * b,
    "/": (a, b) => a / b,
  };
}

const maths = new Maths();
export { Maths, maths };